<template>
    <button type="button" :class="[
        'inline-flex items-center gap-3 rounded-full ps-1.5 pe-5 py-1.5 transition-colors shrink-0',
        active
            ? 'bg-brand-500 text-on-brand'
            : 'bg-card border border-card text-header hover:border-brand-500'
    ]">
        <span :class="[
            'flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold',
            active ? 'bg-white text-brand-600' : 'bg-brand-500/10 text-card'
        ]">
            {{ index }}
        </span>
        <span class="text-start leading-tight">
            <span class="block font-bold text-sm">{{ group.dayLabel }}</span>
            <span :class="['block text-[11px]', active ? 'text-on-brand/80' : 'text-body/80']">
                {{ group.shortLabel }}
            </span>
        </span>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AgendaGroup } from './agenda';

const props = defineProps<{ group: AgendaGroup; active?: boolean; number?: number }>();

const index = computed(() => props.number ?? Number((props.group.dayLabel.match(/\d+/) || ['1'])[0]));
</script>

<style scoped>
.border-app {
    border-color: rgb(var(--core-app-border));
}

.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}
</style>
